import "@shoelace-style/shoelace";
import { setBasePath } from "@shoelace-style/shoelace/dist/utilities/base-path.js";
import "./app-root";
// Set the base path to the folder you copied Shoelace's assets to
setBasePath("/");
